import { isDesktop } from '@/helpers/userAgentHelper'
import { OperatingCompleteRequest } from '@/types/api'
import { service as client } from '@/apis/client'
import qs from 'querystring'

export const complete = async (req: OperatingCompleteRequest): Promise<any> => {
  if (process.env.NODE_ENV === 'development' || isDesktop()) {
    delete req.lat
    delete req.lng
  }
  return (await client.post<any>('/complete', req))
}

export const reset = async (req: any): Promise<any> => {
  return (await client.post<any>(`/devices/${req.deviceId}/reset`, req)).data
}

export const getDevices = async (req: any): Promise<any> => {
  return (await client.get<any>(`/devices?${qs.stringify(req)}&t=${Date.now()}`)).data
}

export const getDeviceLastTripLocation = async (req: any): Promise<any> => {
  return (await client.get<any>(`/devices/${req.deviceId}/last-trip-locations?t=${Date.now()}`)).data
}

export const getDeviceNotFoundHistories = async (req: any): Promise<any> => {
  return (await client.get<any>(`/devices/${req.deviceId}/completes/not_found/histories?t=${Date.now()}`)).data
}

export const playBeepSound = async (req: any): Promise<any> => {
  return (await client.post<any>(`/devices/${req.deviceId}/beep`, req)).data
}

export const addMaintenanceComments = async (req: any): Promise<any> => {
  return (await client.post<any>(`/maintenances/${req.maintenanceId}/comments`, req)).data
}

export const getMaintenanceBasePointHistories = async (req: any): Promise<any> => {
  return (await client.get<any>(`/maintenances/${req.maintenanceId}/base_point/histories?t=${Date.now()}`)).data
}

export const getRelocationBasePointHistories = async (req: any): Promise<any> => {
  return (await client.get<any>(`/relocations/${req.relocationId}/base_point/histories?t=${Date.now()}`)).data
}

export const getBasePoint = async (): Promise<any> => {
  return (await client.get<any>(`/base_points?t=${Date.now()}`)).data
}
